document.addEventListener("DOMContentLoaded", function () {

  let swipers = {};

  function initSwiper(container) {

    if (!container) return;

    const btnPrev = container.querySelector(".collection_tab__button-prev");
    const btnNext = container.querySelector(".collection_tab__button-next");

    const swiper = new Swiper(container, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,

      observer: true,
      observeParents: true,

      breakpoints: {
        0: {
          slidesPerView: 1
        },
        576: {
          slidesPerView: 2
        },
        990: {
          slidesPerView: 3
        },
        1100: {
          slidesPerView: 4
        }
      },

      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev
      }

    });

    swipers[container.id] = swiper;

  }

  function destroyAllSwipers() {

    Object.values(swipers).forEach(function (swiper) {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });

    swipers = {};

  }

  /* INIT FIRST TAB */
  const firstTab = document.querySelector(".section-tab-content.active.swiper--collection_tab");

  if (firstTab) {
    initSwiper(firstTab);
  }

  /* TAB CLICK */
  document.querySelectorAll(".section-tab").forEach(function (tab) {

    tab.addEventListener("click", function (e) {

      e.preventDefault();

      const section = tab.closest(".collection-tabs");
      const targetId = tab.dataset.tab;

      section.querySelectorAll(".section-tab").forEach(el => el.classList.remove("active"));
      section.querySelectorAll(".section-tab-content").forEach(el => el.classList.remove("active"));

      tab.classList.add("active");

      const target = section.querySelector("#" + targetId);

      if (!target) return;

      target.classList.add("active");

      if (target.classList.contains("swiper--collection_tab")) {

        destroyAllSwipers();

        requestAnimationFrame(function () {
          initSwiper(target);
        });

      }

    });

  });

  /* WINDOW RESIZE FIX */
  window.addEventListener("resize", function () {

    const activeTab = document.querySelector(".section-tab-content.active.swiper--collection_tab");

    if (!activeTab) return;

    destroyAllSwipers();

    requestAnimationFrame(function () {
      initSwiper(activeTab);
    });

  });

});